var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import Close from 'wix-ui-icons-common/on-stage/Close';
import { IconButton } from '../IconButton';
import { Text } from '../Text';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { POPOVER_DATA_KEYS } from './dataHooks';
import { KEY_CODES } from '../../common/keyCodes';
import { st, classes } from './CalendarPopover.st.css';
import { CalendarPopoverSides, } from './types';
/** CalendarPopover */
var CalendarPopover = /** @class */ (function (_super) {
    __extends(CalendarPopover, _super);
    function CalendarPopover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconRef = React.createRef();
        _this.lastActiveElement = null;
        _this.getDataAttributes = function () {
            var _a;
            var _b = _this.props, withShadow = _b.withShadow, withArrow = _b.withArrow, arrowSide = _b.arrowSide, title = _b.title, arrowTop = _b.arrowTop, animated = _b.animated, isShown = _b.isShown, manualFocus = _b.manualFocus;
            return _a = {},
                _a[POPOVER_DATA_KEYS.ArrowTop] = arrowTop,
                _a[POPOVER_DATA_KEYS.ArrowSide] = arrowSide,
                _a[POPOVER_DATA_KEYS.Title] = title,
                _a[POPOVER_DATA_KEYS.WithArrow] = withArrow,
                _a[POPOVER_DATA_KEYS.WithShadow] = withShadow,
                _a[POPOVER_DATA_KEYS.Animated] = animated,
                _a[POPOVER_DATA_KEYS.Shown] = isShown,
                _a[POPOVER_DATA_KEYS.ManualFocus] = manualFocus,
                _a;
        };
        _this._focusLastActive = function () {
            !_this.props.manualFocus &&
                _this.lastActiveElement &&
                _this.lastActiveElement.focus();
        };
        _this._onEsc = function (e) {
            if (e.keyCode === KEY_CODES.Esc) {
                _this.props.onClose();
            }
        };
        _this._manageA11y = function () {
            if (_this.props.isShown) {
                document.addEventListener('keyup', _this._onEsc);
                _this.lastActiveElement = document.activeElement;
                !_this.props.manualFocus && _this.iconRef.current.focus();
            }
        };
        return _this;
    }
    CalendarPopover.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.isShown) {
            this._manageA11y();
        }
        else if (!this.props.isShown) {
            document.removeEventListener('keyup', this._onEsc);
            this._focusLastActive();
        }
    };
    CalendarPopover.prototype.componentDidMount = function () {
        this._manageA11y();
    };
    CalendarPopover.prototype.componentWillUnmount = function () {
        document.removeEventListener('keyup', this._onEsc);
        this._focusLastActive();
    };
    CalendarPopover.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, title = _a.title, onClose = _a.onClose, withArrow = _a.withArrow, arrowSide = _a.arrowSide, arrowTop = _a.arrowTop, withShadow = _a.withShadow, isShown = _a.isShown, animated = _a.animated, className = _a.className, closeAriaLabel = _a.closeAriaLabel;
        var pxArrowTop = arrowTop + "px";
        var titleToRender = typeof title === 'string' ? (React.createElement(Text, { className: classes.title }, title)) : (title);
        return (React.createElement(TPAComponentsConsumer, null, function (_a) {
            var rtl = _a.rtl;
            return (React.createElement("div", __assign({ className: st(classes.root, { rtl: rtl, arrowSide: arrowSide, withArrow: withArrow, withShadow: withShadow, isShown: isShown, animated: animated }, className), "data-hook": _this.props['data-hook'] }, _this.getDataAttributes()),
                React.createElement("div", { className: classes.contentContainer },
                    titleToRender,
                    React.createElement("div", { className: classes.content }, children)),
                React.createElement(IconButton, { className: classes.close, onClick: onClose, "aria-label": closeAriaLabel, icon: React.createElement(Close, null), innerRef: _this.iconRef }),
                React.createElement("div", { className: classes.arrow, style: { top: pxArrowTop } }),
                React.createElement("div", { className: classes.arrowBorder + " " + classes.arrow, style: { top: pxArrowTop } })));
        }));
    };
    CalendarPopover.displayName = 'CalendarPopover';
    CalendarPopover.defaultProps = {
        title: '',
        withArrow: true,
        arrowSide: CalendarPopoverSides.Left,
        arrowTop: 42,
        withShadow: true,
        isShown: false,
        animated: false,
        manualFocus: false,
    };
    return CalendarPopover;
}(React.Component));
export { CalendarPopover };
//# sourceMappingURL=CalendarPopover.js.map